<template>
	<van-dialog
		class="custom-modal"
		:class="classname || ''"
		v-model="show"
		get-container="body"
		:showConfirmButton="type == 'confirm'"
		:show-cancel-button="type == 'confirm'"
		:confirmButtonText="ConfirmText"
		:closeOnPopstate="true"
		:cancelButtonText="cancelButtonText"
		@confirm="onConfirm"
		@cancel="onCancel"
		@customClosed="customClosed"
		@customSure="customSure"
	>
		<div slot="title">
			<img class="icon" v-if="icon && icon != 'none'" :src="icon" />
			<div v-else-if="icon == 'none'"></div>
			<img class="icon" v-else-if="type == 'success'" :src="successIcon" />
			<img class="icon" v-else-if="type == 'confirm'" :src="confirmIcon" />
			<img class="icon" v-else-if="type == 'alert'" :src="confirmIcon" />
			<div v-if="title" class="title">{{ title }}</div>
		</div>
		<div v-if="type == 'confirm'" class="content confirm" v-html="content || title"></div>
		<div v-else class="content" v-html="content"></div>

		<van-button
			v-if="type != 'confirm' && classname != 'upgradepopup'"
			@click="customSureFun"
			class="custom-button"
			color="#C9AD6E"
			round
			>{{ successBtnText }}</van-button
		>
		<div class="footbtn" v-else-if="classname == 'upgradepopup'">
			<van-button
				@click="customSureFun"
				class="custom-button"
				round
				color="linear-gradient(to right, #F5DDC2, #DAB191)"
				>{{ successBtnText }}</van-button
			>
		</div>
		<div v-if="showClose" class="close" @click="close"></div>
	</van-dialog>
</template>
<script>
import { Dialog } from 'vant';
export default {
	name: 'modal',
	components: { [Dialog.name]: Dialog },
	data() {
		return {
			show: true,
			successIcon: require('@/assets/img/aaa.png'),
			confirmIcon: require('@/assets/img/aaa.png'),
			title: '',
			content: '',
			classname: '',
			successBtnText: '',
			type: 'success',
			showClose: false,
			icon: false,
			onConfirm() {},
			onCancel() {},
		};
	},
	methods: {
		close() {
			if (typeof this.customClosed == 'function') {
				this.customClosed();
			}
			this.classname = '';
			this.show = false;
		},
		customSureFun() {
			if (typeof this.customSure == 'function') {
				this.customSure();
			}
			this.show = false;
			this.classname = '';
		},
	},
};
</script>
<style lang="less">
.custom-modal.van-dialog {
	border-radius: 32px;
	width: 540px;
	overflow: unset;
	.van-dialog__header {
		padding-top: 50px;
		.icon {
			width: 110px;
			height: 110px;
			margin-bottom: 40px;
		}
		.title {
			margin-bottom: 12px;
			font-size: 40px;
			color: #333;
			line-height: 40px;
		}
	}
	.van-dialog__content {
		padding: 0 40px;
		text-align: center;
	}
	.van-dialog__footer {
		border-radius: 0 0 32px 32px;
		.van-dialog__confirm {
			background: #c9ad6e;
			color: #fff;
		}
	}
	.content {
		font-size: 24px;
		color: #999;
		&.confirm {
			margin-bottom: 100px;
			font-size: 30px;
			color: #555;
		}
	}
	.custom-button {
		width: 280px;
		height: 70px;
		line-height: 66px;
		font-size: 32px;
		margin-top: 30px;
		margin-bottom: 42px;
	}
	.close {
		position: absolute;
		bottom: -110px;
		left: 50%;
		transform: translateX(-50%);
		width: 60px;
		height: 60px;
		background: url('../../assets/img/aaa.png') no-repeat center/100% 100%;
	}
	.van-button--large {
		height: 90px;
	}
	.van-button {
		font-size: 26px;
	}
	.van-dialog__cancel {
		background-color: #f0f0f0;
	}
	.reg-table {
		background: #f2ebe1;
		border: 1px solid #f2ebe1;
		border-radius: 8px;
		margin-top: 14px;
		> .reg-alert {
			height: 60px;
			line-height: 60px;
			border-bottom: 1px solid #fff;
			color: #0e0c14;
			display: flex;
			> span {
				display: inline-block;
				width: 30%;
				padding-left: 10px;
				border-right: 1px solid #fff;
				font-size: 24px;
				color: #474747;
				&:last-child {
					width: 70%;
					padding-left: 5px;
					border: none;
					text-align: center;
				}
			}
			.pw_input{
				width: 100%;
				text-align: center;
				padding-right: .36rem;
				height: 0.6rem;
				line-height: 0.6rem;
			}
		}
	}
}
div.custom-modal.van-dialog.upgradepopup {
	border-radius: 0;
	overflow: visible;
	width: 658px;
	background: url('~@/assets/img/aaa.png') no-repeat center;
	min-height: 600px;
	background-size: 100% 100%;
	.van-dialog__header {
		padding-top: 0;
	}
	.van-dialog__content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		max-height: none;
		.content {
			width: 500px;
			margin: 46px auto 0;
			text-align: left;
			// flex: 73.57 0 auto;
			min-height: 620px;
			.tit {
				font-size: 58px;
				color: #bd7435;
				width: 400px;
				margin: 0 auto;
			}
			.tit2 {
				font-size: 30px;
				color: #7f523a;
				width: 400px;
				margin: 24px auto 0;
			}
			.tit3 {
				background-color: #7f523a;
				height: 50px;
				line-height: 50px;
				width: 100%;
				color: #ffba00;
				border-radius: 10px;
				text-align: center;
				letter-spacing: 1pt;
				width: 400px;
				margin: 16px auto 8px;
			}
			ul.rights {
				display: flex;
				justify-content: start;
				flex-wrap: wrap;
				align-items: center;
				width: 440px;
				margin: 0 auto;
				position: relative;
				left: 18px;
				> li {
					color: #7f523a;
					font-size: 24px;
					height: 48px;
					text-align: left;
					width: 49%;
					overflow: hidden;
					display: flex;
					justify-content: start;
					align-items: center;
					> p {
						line-height: 24px;
						height: 24px;
						font-weight: bold;
					}
					> s {
						width: 6px;
						height: 6px;
						border-radius: 50%;
						background-color: #7f523a;
						display: block;
						margin-right: 10px;
					}
				}
			}
		}
		.footbtn {
			min-height: 220px;
			// flex: 26.43 0 auto;
			// background-color: #ffc0cb4d;
			display: flex;
			flex-direction: column;
			justify-content: center;
			> button {
				margin: auto;
				color: #6d3719 !important;
			}
		}
	}
}

</style>
